/* SG Med / Pursuit variant identity safeguard (2026-10-20).
   Aligns the exact customer-selected option with Shopify's variant ID before cart submission.
   Affects product forms with multiple variants, including AJAX/quick-view forms.
   Does not alter prices, inventory, promotions, or checkout rules. */
(function () {
  'use strict';
  var selections = new WeakMap();
  var cache = new WeakMap();
  function sectionFor(form) {
    return form && form.closest && form.closest('[data-section-type="product"]');
  }
  function dataFor(form) {
    var section = sectionFor(form);
    if (!section) return null;
    var node = section.querySelector('script[data-product-json]');
    if (!node) return null;
    var stored = cache.get(node);
    if (stored) return stored;
    try {
      var parsed = JSON.parse(node.textContent);
      if (!parsed || !parsed.product || !Array.isArray(parsed.product.variants)) return null;
      cache.set(node, parsed.product);
      return parsed.product;
    } catch (e) {
      console.error('SGMED variant JSON parsing failed:', e);
      return null;
    }
  }
  function changeDetails(target) {
    if (!target || !target.matches) return null;
    if (target.matches('select.single-option-selector[data-index]')) {
      var m = /^option(\d+)$/.exec(target.getAttribute('data-index') || '');
      return m ? {index: Number(m[1]) - 1, value: target.value} : null;
    }
    if (target.matches('.swatch input[type="radio"][data-option-value]')) {
      var wrapper = target.closest('.swatch[data-option-index]');
      return wrapper ? {index: Number(wrapper.getAttribute('data-option-index')), value: target.getAttribute('data-option-value')} : null;
    }
    return null;
  }
  function valuesFor(form, product) {
    var section = sectionFor(form);
    var choice = selections.get(form) || {};
    var count = Array.isArray(product.options) ? product.options.length : 0;
    var values = [];
    for (var i = 0; i < count; i++) {
      var select = section.querySelector('select.single-option-selector[data-index="option' + (i + 1) + '"]');
      var swatch = section.querySelector('.swatch[data-option-index="' + i + '"] input[type="radio"]:checked[data-option-value]');
      var value = Object.prototype.hasOwnProperty.call(choice, i) ? choice[i] : select ? select.value : swatch ? swatch.getAttribute('data-option-value') : null;
      if (value == null || value === '') return null;
      values.push(String(value));
    }
    return values;
  }
  function report(form, message) {
    var output = form.querySelector('[data-sgmed-variant-guard-status]');
    if (!output) {
      output = document.createElement('p');
      output.setAttribute('data-sgmed-variant-guard-status', '');
      output.setAttribute('role', 'alert');
      output.style.cssText = 'font-size:13px;color:#a32727;margin:8px 0;';
      var addButton = form.querySelector('button[name="add"],button.product-form__cart-submit');
      if (addButton && addButton.parentNode) addButton.parentNode.insertBefore(output, addButton);
      else form.appendChild(output);
    }
    output.textContent = message || '';
  }
  function synchronize(form, showError) {
    if (!form) return true;
    var product = dataFor(form);
    if (!product || product.variants.length < 2) return true;
    var canonical = form.querySelector('select[name="id"],input[name="id"]');
    if (!canonical) {
      if (showError) report(form, 'Please reload this page before adding the item.');
      return false;
    }
    var values = valuesFor(form, product);
    if (!values) {
      if (showError) report(form, 'Please choose an option before adding the item.');
      return false;
    }
    var match = product.variants.find(function (variant) {
      return Array.isArray(variant.options) &&
        variant.options.length === values.length &&
        variant.options.every(function (value, index) { return String(value) === values[index]; });
    });
    if (!match) {
      if (showError) report(form, 'This combination is not available. Please choose another option.');
      return false;
    }
    canonical.value = String(match.id);
    if (String(canonical.value) !== String(match.id)) {
      if (showError) report(form, 'Unable to confirm the selected size. Please reload and try again.');
      return false;
    }
    if (showError) report(form, '');
    return true;
  }
  window.addEventListener('change', function (event) {
    var details = changeDetails(event.target);
    if (!details || !Number.isInteger(details.index) || details.index < 0) return;
    var form = event.target.closest('form[data-product-form]');
    if (!form) return;
    var state = selections.get(form) || {};
    state[details.index] = details.value;
    selections.set(form, state);
    // Reassert after any legacy theme change handlers replace the hidden Shopify ID.
    Promise.resolve().then(function () { synchronize(form, false); });
    setTimeout(function () { synchronize(form, false); }, 0);
  }, true);
  function guard(event, form) {
    if (synchronize(form, true)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }
  window.addEventListener('click', function (event) {
    var button = event.target && event.target.closest && event.target.closest('button[name="add"],button.product-form__cart-submit');
    if (!button) return;
    var form = button.closest('form[data-product-form]');
    if (form) guard(event, form);
  }, true);
  window.addEventListener('submit', function (event) {
    if (event.target && event.target.matches && event.target.matches('form[data-product-form]')) guard(event, event.target);
  }, true);
}());